export default {
    config: {
        fixedWidth: 48
    },
    default: {
        label: 'Buddies'
    },
    unique: [],
    sort: 'rating.buddies',
    lang: {
        name: 'Group Rating',
        category: 'User',
        description: 'Group average rating of the game.',
        views: ['list', 'sheet', 'grid'],
    },
    types: ['buddies'],
    filters: []
}